import React from "react";
import { motion as Motion } from "framer-motion";

export default function GalleryGrid({
  items = [],
  videoThumbnails = {},
  onOpen,
}) {
  return (
    <Motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1 }}
      variants={{
        hidden: { opacity: 0 },
        visible: {
          opacity: 1,
          transition: { staggerChildren: 0.08 },
        },
      }}
      className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 xl:grid-cols-3 xl:gap-6"
    >
      {items.map((item, index) => (
        <Motion.button
          key={item.id}
          type="button"
          variants={{
            hidden: { opacity: 0, y: 18 },
            visible: {
              opacity: 1,
              y: 0,
              transition: { duration: 0.45, ease: "easeOut" },
            },
          }}
          onClick={() => onOpen(index)}
          className="group relative overflow-hidden rounded-[1.35rem] md:rounded-[1.6rem] xl:rounded-[1.75rem] surface-card shadow-soft text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F4B400]/50"
        >
          <div className="relative aspect-[5/4] sm:aspect-[4/3] xl:aspect-[5/4] overflow-hidden bg-[#1A1C25]">
            {item.type === "photo" ? (
              <img
                src={item.src}
                alt={item.caption}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
              />
            ) : (
              <>
                {videoThumbnails[item.src] ? (
                  <img
                    src={videoThumbnails[item.src]}
                    alt=""
                    loading="lazy"
                    aria-hidden="true"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                ) : (
                  <div className="h-full w-full bg-[#1A1C25]" aria-hidden="true" />
                )}
                <div className="absolute inset-0 flex items-center justify-center bg-black/20 transition-colors duration-300 group-hover:bg-black/30">
                  <div className="flex h-14 w-14 sm:h-16 sm:w-16 items-center justify-center rounded-full bg-[#F4B400] text-[#1A1C25] shadow-lift">
                    <svg
                      className="ml-1 h-6 w-6 sm:h-7 sm:w-7 fill-current"
                      viewBox="0 0 24 24"
                      aria-hidden
                    >
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
              </>
            )}

            <div className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
            <div className="absolute left-3 top-3 rounded-full bg-white/90 px-3 py-1 text-[10px] font-inter font-black uppercase tracking-[0.24em] text-[#7D192A] sm:left-4 sm:top-4">
              {item.type === "video" ? "Video" : "Photo"}
            </div>
          </div>
        </Motion.button>
      ))}
    </Motion.div>
  );
}
